export const NEW_ADMIN_SAGAS = 'NEWADMINSAGAS';
